export default "__VITE_ASSET__1a470fa2__"